<template>
<div>
  <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
  <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
   <div class=" container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
      <div>
               <nav class="navbar navbar-expand-lg  bg-info text-white">
                    <span><b>Inhouse Goal Assignment</b></span>
               </nav>
               <div v-if="saved">
                    <p align ="center" class="confirm-message"> {{message}} </p>
                </div>
                <div v-if="failure">
                    <p align ="center" class="alert-danger"> {{failureMessage}} </p>
                </div>
                <div class="row p-2 justify-content-center">
                   <div class="col">
                     <div class="table-responsive table-responsive-sm">
                       <table class="table table-sm table-bordered table-striped small">
                        <thead>
                          <tr class="table-month-header-red">
                            <th  v-for="(col,index) in colheaders"  v-if="index <=2" rowspan="2"  :key="index" >{{col.header}}</th>
                            <th  v-for="(m,index) in months" :key="index">{{ m.month }}</th>
                          </tr>
                          <tr class=table-month-header-blue>
                            <th   v-for="(col,index) in colheaders" :key="index"  v-if="index >2" >{{col.header}}</th>
                          </tr>
                        </thead>
                        <tbody>
                            <template v-for="(dealer,i) in assignedgoals">
                               <template v-for="(goal, j) in dealer.goalSubCategory">
                                   <tr>
                                      <td v-if="j == 0"  :rowspan="dealer.goalSubCategory.length">{{dealer.source}}</td>
                                      <td v-if="j == 0" :rowspan="dealer.goalSubCategory.length">{{dealer.goalCategory}}</td>
                                      <td >{{goal.name}}</td>
                                      <template v-for="(month,k) in goal.monthly">
                                        <td :class="getCellColor(k)"  v-if="isReadonly(k)" >
                                          {{month.expected}}
                                          </td>
                                          <td v-else :class="getCellColor(k)" >
                                            <input type="text" v-validate="'numeric'" @input="onlyNumbers()" name="expected" :id="'expected' +goal.name + month.monthName " v-model.trim="month.expected" size="1" :maxlength="2">
                                          </td>
                                      </template>
                                    </tr>
                                  </template>
                              </template>
                        </tbody>
                      </table>
                    </div>
                </div><!--col end-->
            </div><!--row end-->
            <div class="horizontal-line"></div>
             <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center">
                  <div class="col  justify-content-end align-items-center ">
                      <button id="savebtn"  type="submit" @click="saveGoals" class="btn btn-secondary ml-3" > Save </button>
                  </div><!--col end-->
                </div><!--row end-->
           </div>
      </div>
   <bottom-footer></bottom-footer>
        </div>
  </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import goalsjson from '../json/scheduleddealers.json'
import manageSourceSvc from '../js/http-managesource'
import util from '../js/common-utils'
import moment from 'moment'

export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      updateGoals: false, // Becomes true only if records exists
      saved: false,
      message: '',
      failure: false,
      failureMessage: "We're unable to save inhouse goals",
      months: [
        { month: 'Jan' },
        { month: 'Feb' },
        { month: 'Mar' },
        { month: 'Apr' },
        { month: 'May' },
        { month: 'Jun' },
        { month: 'Jul' },
        { month: 'Aug' },
        { month: 'Sep' },
        { month: 'Oct' },
        { month: 'Nov' },
        { month: 'Dec' }
      ],
      colheaders: [
        { header: 'Source' },
        { header: 'Goal Category' },
        { header: 'Goal type' }, // Also known as Goal Sub Category
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' },
        { header: 'Exp' }
      ],
      assignedgoals: [
        {
          source: 'Inhouse',
          goalCategory: 'Dealer Transactions',
          goalCategoryC: 'DTX',
          goalSubCategory:
        [
          {
            name: 'Quotes',
            code: 'QT',
            monthly: [
              { monthName: 'Jan', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Feb', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'March', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'April', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'May', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'June', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Jul', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Aug', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Sep', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Oct', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Nov', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Dec', expected: '', inhouseId: '', creationD: '', creationUserI: '' }
            ]
          },
          { name: 'Apps',
            code: 'APS',
            monthly: [
              { monthName: 'Jan', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Feb', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'March', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'April', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'May', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'June', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Jul', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Aug', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Sep', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Oct', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Nov', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Dec', expected: '', inhouseId: '', creationD: '', creationUserI: '' }
            ]
          },
          { name: 'Deals',
            code: 'DLS',
            monthly: [
              { monthName: 'Jan', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Feb', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'March', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'April', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'May', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'June', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Jul', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Aug', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Sep', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Oct', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Nov', expected: '', inhouseId: '', creationD: '', creationUserI: '' },
              { monthName: 'Dec', expected: '', inhouseId: '', creationD: '', creationUserI: '' }
            ]
          }
        ]
        }
      ]
    }
  },
  methods: {
    onlyNumbers: function () {
      this.assignedgoals.forEach(agoal => { // iterate through TOp Array ( only one element but keeping is consistent)
        var goalSubcategories = agoal.goalSubCategory
        // Iterate through Sub categories
        goalSubcategories.forEach(goalsubcat => {
          goalsubcat.monthly.forEach(monthentry => {
            monthentry.expected = monthentry.expected.replace(/[^0-9]/, '')
          })
        })
      })
    },
    getCellColor: function (monthNum) {
      var currentMonth = new Date().getMonth()
      if (monthNum === currentMonth) { return 'bg-warning' } else if (monthNum < currentMonth) { return 'bg-secondary' } else { return 'bg-success' }
    },
    isReadonly: function (monthNum) {
      var currentMonth = new Date().getMonth()
      if (monthNum < currentMonth) { return true } else { return false }
    },
    getdateformonthname: function (name) {
      var date = new Date()
      if (name == 'Jan') {
        return date.getFullYear() + '-' + '01' + '-' + '01'
        // return '01/01/'+date.getFullYear();
      } else if (name == 'Feb') {
        return date.getFullYear() + '-' + '02' + '-' + '01'
        // return ('02/01/'+date.getFullYear());
      } else if (name == 'March') {
        return date.getFullYear() + '-' + '03' + '-' + '01'
        // return ('03/01/'+date.getFullYear());
      } else if (name == 'April') {
        return date.getFullYear() + '-' + '04' + '-' + '01'
        // return ('04/01/'+date.getFullYear());
      } else if (name == 'May') {
        return date.getFullYear() + '-' + '05' + '-' + '01'
        // return ('05/01/'+date.getFullYear());
      } else if (name == 'June') {
        return date.getFullYear() + '-' + '06' + '-' + '01'
        // return ('06/01/'+date.getFullYear());
      } else if (name == 'Jul') {
        return date.getFullYear() + '-' + '07' + '-' + '01'
        // return ('07/01/'+date.getFullYear());
      } else if (name == 'Aug') {
        return date.getFullYear() + '-' + '08' + '-' + '01'
        // return ('08/01/'+date.getFullYear());
      } else if (name == 'Sep') {
        return date.getFullYear() + '-' + '09' + '-' + '01'
        // return ('09/01/'+date.getFullYear());
      } else if (name == 'Oct') {
        return date.getFullYear() + '-' + '10' + '-' + '01'
        // return ('10/01/'+date.getFullYear());
      } else if (name == 'Nov') {
        return date.getFullYear() + '-' + '11' + '-' + '01'
        // return ('11/01/'+date.getFullYear());
      } else if (name == 'Dec') {
        return date.getFullYear() + '-' + '12' + '-' + '01'
        // return ('12/01/'+date.getFullYear());
      }
    },
    getsubcatcodes: function (subcatname) {
      if (subcatname == 'Quotes') {
        return 'QT'
      } else if (subcatname == 'Apps') {
        return 'APS'
      } else if (subcatname == 'Deals') {
        return 'DLS'
      }
    },
    saveGoals () {
      let goalsToSave = []
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.assignedgoals.forEach(agoal => { // iterate through TOp Array ( only one element but keeping is consistent)
            var goalSubcategories = agoal.goalSubCategory
            // Iterate through Sub categories
            goalSubcategories.forEach(goalsubcat => {
              goalsubcat.monthly.forEach(monthentry => {
                if (this.updateGoals) {
                  let goaltempupdate = {
                    'inhouseId': monthentry.inhouseId,
                    'inhouseSourceName': 'Inhouse',
                    'goalCategoryC': 'DTX', // Dealer Transactions
                    'goalSubCategoryC': goalsubcat.code,
                    'goalMonth': util.strToDate(this.getdateformonthname(monthentry.monthName)),
                    'expectedCount': monthentry.expected,
                    // "lastUpdatedD": currentDate,
                    'lastUpdatedUserI': this.$session.get('user_id'),
                    'creationD': monthentry.creationD,
                    'creationUserI': monthentry.creationUserI
                  }
                  goalsToSave.push(goaltempupdate)
                } else {
                  // Create-For Create send all records -Create happens only once
                  let goaltempsave = {
                    'inhouseSourceName': 'Inhouse',
                    'goalCategoryC': 'DTX', // Dealer Transactions
                    'goalSubCategoryC': goalsubcat.code, // this.getsubcatcodes(goalsubcat.name),
                    'goalMonth': util.strToDate(this.getdateformonthname(monthentry.monthName)),
                    'expectedCount': monthentry.expected,
                    // "creationD": currentDate,
                    'creationUserI': this.$session.get('user_id'),
                    'lastUpdatedD': null,
                    'lastUpdatedUserI': null
                  }
                  goalsToSave.push(goaltempsave)
                } // END else
              })
            }) /// end of sub category loop
          }) // end of top array loop
          // console.log("Inhouse goals to be saved: " + JSON.stringify( goalsToSave));
          if (this.updateGoals) {
            manageSourceSvc.put('/inhouse/assigned-goals', goalsToSave).then(response => {
              var status = response.data
              if (status == 'ACCEPTED') {
                this.saved = true
                this.message = 'Inhouse Goals have been updated successfully!!!'
              }
            })
              .catch(e => {
                console.log('Error in updating Inhouse assigned Goals: ' + e)
                this.failure = true
              })
          } else {
            manageSourceSvc.post('/inhouse/assigned-goals', goalsToSave).then(response => {
              var status = response.data
              if (status == 'CREATED') {
                // TODO -Add Success Message
                this.saved = true
                this.message = 'Inhouse Goals have been saved successfully!!!'
              }
            })
              .catch(e => {
                console.log('Error in saving Inhouse assigned Goals: ' + e)
                // TODO - Add Error Message
                this.failure = true
              })
          }// END else
        }
      })
    },
    fetchData () {
      manageSourceSvc.get('/inhouse/assigned-goals').then(response => {
        var retrievedgoals = response.data

        if (retrievedgoals.length > 0) {
          this.updateGoals = true
          this.assignedgoals.forEach(agoal => { // iterate through TOp Array ( only one element but keeping is consistent)
            var goalSubcats = agoal.goalSubCategory
            // Iterate through Sub categories
            goalSubcats.forEach(goalsubcat => {
              goalsubcat.monthly.forEach(monthe => {
                // Now iterate through Results and update 1. inhouseID, 2.Expected count
                retrievedgoals.forEach(retGoal => {
                  if ((retGoal.goalSubCategoryC == goalsubcat.code) &&
              (moment(retGoal.goalMonth).format('YYYY-MM-DD') == this.getdateformonthname(monthe.monthName))
                  ) {
                    monthe.inhouseId = retGoal.inhouseId
                    monthe.expected = retGoal.expectedCount
                    monthe.creationD = retGoal.creationD
                    monthe.creationUserI = retGoal.creationUserI
                  }
                }) // End of iterating through Retrieved Goals
              })
            }) /// end of sub category loop
          }) // end of top array loop
        }
      })
        .catch(e => {
          console.log('Error in getting assigned Goals: ' + e)
          this.errors.push(e)
        })
    },

    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#customer').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt + 2)
      console.log(txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData() // Get Assigned goal on the page load
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>

</style>
